// React
import React, { useState } from "react";
// React
// CSS
import styles from "./Wallet.module.css";
// CSS
// images
// images
// Utils
import WalletModal from "./WalletModal/WalletModal";
// Utils
// Icons
import { FiPlus } from "react-icons/fi";
// Icons

type WalletProps = {
  walletData: {
    wallet: number | string;
    giftWallet: number | string;
  };
};

const Wallet: React.FunctionComponent<WalletProps> = ({
  walletData: { giftWallet, wallet },
}) => {
  const [isModalInScreen, setIsModalInScreen] = useState<boolean>(false);
  return (
    <div
      className={`${styles.walletContainer} mx-4 p-2 mt-4 rounded-xl flex flex-row-reverse items-center justify-between h-30`}
    >
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}

      <div
        onClick={() => {
          setIsModalInScreen(true);
        }}
        className={`${styles.addToCreditBtn} flex items-center justify-between flex-col p-2  py-4 rounded-lg
        `}
      >
        <FiPlus style={{ color: "rgb(126, 58, 209)" }} className="" />
        <span
          className="block mt-2 w-full text-xs text-center"
          style={{ color: "rgb(126, 58, 209)" }}
        >
          افزایش اعتبار
        </span>
      </div>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      <div
        className={`${styles.content} flex flex-col items-center justify-between  h-full `}
      >
        <p>
          <span>کــیــف پــول</span>
          <span className="text-xs flex items-center justify-center">
            تومان
            <span className="text-base ml-1">{wallet}</span>
          </span>
        </p>
        <p>
          <span>کیف پول هدیه</span>
          <span className="text-xs flex items-center justify-center">
            تومان
            <span className="text-base ml-1">{giftWallet}</span>
          </span>
        </p>
      </div>
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/* MODAL */}
      {isModalInScreen ? (
        <WalletModal setIsModalInScreen={setIsModalInScreen} />
      ) : (
        <></>
      )}
      {/* MODAL */}
    </div>
  );
};

export default Wallet;
